import React from "react";

import formatCurrency from "Utils/formatCurrency";

import { enrollmentForOverview, chooseCoverageRows } from "../Utils/chooseCoverage";
import { Card, CardHeader, CardSection } from "Common/Card";
import { Row, Col } from "Common/Grid";
import InfoPopover from "Common/InfoPopover";
import { Table } from "Common/Table";

import type { FamilyInfo } from "../Utils/chooseCoverage";
import type { ContributionFormula, FamilyQuote } from "Utils/types";

import makeBem from "Utils/makeBem";

type Props = {
  plan: any;
  prices: FamilyQuote;
  contributions: ContributionFormula;
  familyInfo: Array<FamilyInfo>;
};

const bem = makeBem("EmployeeCoveragePriceTable");

const PriceTable = ({ plan, prices, familyInfo, contributions }: Props) => (
  <Card theme="flat" p={0} className={bem()} id="planOverview">
    <CardHeader>Premium Overview</CardHeader>
    <CardSection>
      <Row>
        <Col>
          <Table striped>
            <thead style={{ textAlign: "left" }}>
              <tr className="category-row">
                <th style={{ width: "50%" }}>Family Member</th>
                <th>
                  Your Cost
                  <InfoPopover
                    infoTitle="Payroll Contributions"
                    infoText="This is the amount you pay each month, taken directly out of your paycheck."
                    placement="top"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {chooseCoverageRows(familyInfo, [prices], contributions, enrollmentForOverview([prices], familyInfo), plan.type).map((row) => (
                <tr key={row.label} className={bem("row", row.type)}>
                  <td>{row.label}</td>
                  <td>{`${formatCurrency(row.prices[0])}/mo`}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </CardSection>
  </Card>
);

export default PriceTable;
